module.exports = __webpack_public_path__ + "static/img/groundabout5.87ff3a59.png";